import React from 'react';
import ReactDOM from 'react-dom/client';
import "../src/bootstrap.css";
// import "./bootstrap.min.css";
import App from './App';
import reportWebVitals from './reportWebVitals';

/* The following line can be included in your src/index.js or App.js file */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
